<template>

    <div class="nav-tabs-custom">
        <div class="tab-content">
            <div class="tab-pane active">
                <server-table
                    v-if="loaded"
                    :add-url="route('projects.details.documents.add', {project_uuid:project.uuid}, false)"
                    :data-url="st.url"
                    :data-columns="JSON.stringify(st.columns)"
                    :preference-url="st.preferenceUrl"
                    :templates-uri="route('api.v1.templates.index')"
                ></server-table>
            </div>
        </div>
    </div>

</template>

<script>

    import { mapGetters } from 'vuex';
    import Lang from '../../../Lang';
    import axios from "axios";
    import ServerTable from "../../../components/Documents/ServerTable";

    export default {

        components: {
            ServerTable,
        },

        computed: {
            ...mapGetters([
                'getProject',
            ]),

            project() {
                return this.getProject;
            },
        },

        data() {
            return {
                Lang:Lang,
                loaded:false,
                st: {
                    columns:[],
                    url:'',
                    preferenceUrl:'',
                },
            }
        },

        metaInfo: {
            title:'Project documenten',
        },

        methods: {
            getProjectDocuments() {
                axios.get(this.route('api.v1.projects.document.st', {project_uuid: this.project.uuid}))
                .then(resp => {
                    this.st = resp.data;
                    this.loaded = true;
                })
            },
        },

        mounted(){
            this.getProjectDocuments();
        },

        name:'ProjectsDetailsDocuments',
    }

</script>
